import Axios from 'axios'

const instance: any = Axios.create({
    baseURL: process.env.REACT_APP_API_URL,
})
console.log(process.env.NODE_ENV, process.env.REACT_APP_API_URL)

export default instance;